/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CmsHome(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CmsHome',
      'aria-hidden': true,
      focusable: false,
      width:  18 * scale,
      height: 16 * scale,
      viewBox: '0 0 18 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M2.52 8 9 2.328 15.48 8H14v6h-2v-1.094l-.018-.092C11.654 11.078 10.512 10 9 10c-1.51 0-2.654 1.078-2.982 2.814L6 12.906V14H4V8zM9 1 1 8v1h2v6h4v-2c.216-1.14.87-2 2-2s1.784.86 2 2v2h4V9h2V8z"}),createElement('path', {"opacity":".2","fill":"currentColor","d":"M2.52 8 9 2.328 15.48 8H14v6h-2v-1.094l-.018-.092C11.654 11.078 10.512 10 9 10c-1.51 0-2.654 1.078-2.982 2.814L6 12.906V14H4V8z"}))
}
